import { FieldBaseTheme } from '../../types';

export const FIELD_BASE_DEFAULT_THEME: FieldBaseTheme = {
    endButtonSize: 's',

    size: {
        s: {
            height: 48,
            labelCenterOffset: 2,
            radius: 6,
            paddingX: 3,
        },
        m: {
            height: 54,
            labelCenterOffset: 2,
            radius: 8,
            paddingX: 3,
        },
        l: {
            height: 64,
            labelCenterOffset: 2.5,
            radius: 8,
            paddingX: 3,
        },
    },
};
